import { defineMessages } from "react-intl";

export default defineMessages({
  "confirmationEmailTop.title": {
    id: "confirmationEmailTop.title",
    defaultMessage: "Finalisez votre inscription",
  },
  "confirmationEmailTop.subTitle": {
    id: "confirmationEmailTop.subTitle",
    defaultMessage: "Cliquez sur le lien reçu dans le mail de confirmation.",
  },
  "confirmationEmailTop.activateEmailCTAText": {
    id: "confirmationEmailTop.activateEmailCTAText",
    defaultMessage: "Activez votre adresse mail",
  },
  "confirmationEmailTop.incorrectEmail": {
    id: "confirmationEmailTop.incorrectEmail",
    defaultMessage: "Your email address {email} appears to be incorrect.",
  },
  "confirmationEmailTop.modifyEmailCTAText": {
    id: "confirmationEmailTop.modifyEmailCTAText",
    defaultMessage: "Modifiez l’email",
  },
  "confirmationEmailTop.modal.header": {
    id: "confirmationEmailTop.modal.header",
    defaultMessage:
      "Validez votre adresse mail pour finaliser votre inscription",
  },
  "confirmationEmailTop.modal.emailSentOn": {
    id: "confirmationEmailTop.modal.emailSentOn",
    defaultMessage: "E-mail envoyé le {date} à {email}",
  },
  "confirmationEmailTop.modal.isNotYourUsualEmailAddress": {
    id: "confirmationEmailTop.modal.isNotYourUsualEmailAddress",
    defaultMessage: "Ce n'est pas votre adresse mail habituelle ?",
  },
  "confirmationEmailTop.modal.modifyEmailLinkText": {
    id: "confirmationEmailTop.modal.modifyEmailLinkText",
    defaultMessage: "Modifier l'adresse mail",
  },
  "confirmationEmailTop.modal.resendEmailCTAText": {
    id: "confirmationEmailTop.modal.resendEmailCTAText",
    defaultMessage: "Renvoyer l'e-mail",
  },
  "confirmationEmailTop.modal.footerText": {
    id: "confirmationEmailTop.modal.footerText",
    defaultMessage:
      "Pas reçu ? Attendez quelques minutes et vérifiez vos spams.",
  },
  "confirmationEmailTop.modal.emailHasBeenSent": {
    id: "confirmationEmailTop.modal.emailHasBeenSent",
    defaultMessage:
      "Email sent successfully.",
  },
  "confirmationEmailTop.modal.errorWhileSendingAnEmail": {
    id: "confirmationEmailTop.modal.errorWhileSendingAnEmail",
    defaultMessage:
      "Error while sending an email.",
  },
});
